import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    useMemo,
} from "react";
import style from "./AdminAddBulkStockNew.module.css";
import Select from "react-select";
import { Grid } from "@mui/material";



export default function AddStockTopSection({ fields, handledropdown, inputselectchange, filteredSupplier, filteredlot, filteredsku, branchOption }) {
    const [previousFields, setPreviousFields] = useState([]);

    useEffect(() => {
        if (fields !== previousFields) {
            console.log('Fields have changed:', fields);
            setPreviousFields(fields); // Update previousFields to trigger re-render on change
        }
    }, [fields]); // Re-run when 'fields' prop changes



    const options = filteredSupplier.map(supplier => ({
        label: supplier.VendorName,  // Display the vendor name
        value: supplier.Id           // Use the Id as the value
    }));

    console.log('checking filteredsupplier ', fields);

    const lotoptions = filteredlot.map(lot => ({
        label: lot.LotNumber,  // Display the vendor name
        value: lot.LotNumber           // Use the Id as the value
    }));

    const skuoptions = filteredsku('top').map(supplier => ({
        label: supplier.StockKeepingUnit,  // Display the vendor name
        value: supplier.Id           // Use the Id as the value
    }));

    const typeoptions = [
        { label: "Labelled", value: "Labelled" },
        { label: "UnLabelled", value: "UnLabelled" }
    ];

    return (
        <div style={{ width: '100%' }}>
            <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 10, lg: 10 }}>
                {fields
                    .filter(
                        (field) =>
                            field.place === "top" &&
                            field.visibility !== "Hidden" &&
                            field.IsVisible !== "Hidden"
                    )
                    .sort((a, b) => a.priority - b.priority)
                    .map((filter, index) => {
                        // Dynamically determine selected option
                        const selectedOption =
                            filter.key === "VendorId"
                                ? options.find((option) => option.value === filter.value)
                                : filter.key === "LotNumber"
                                    ? lotoptions.find((option) => option.value === filter.value)
                                    : filter.key === "SKUId"
                                        ? skuoptions.find((option) => option.value === filter.value)
                                        : null;

                        // Dynamically set options for Select
                        const selectOptions =
                            filter.key === "VendorId"
                                ? options
                                : filter.key === "LotNumber"
                                    ? lotoptions
                                    : filter.key === "SKUId"
                                        ? skuoptions
                                        : [];

                                        console.log('checking top values ', filter.value, '   ', filter);             
                                        

                        return (
                            <Grid
                                key={index}
                                item
                                xs={4}
                                sm={4}
                                md={2}
                                lg={2}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "5px",
                                }}
                            >
                                <label
                                    htmlFor={`filter-${index}`}
                                    style={{
                                        fontSize: "14px",
                                        // fontWeight: "bold",
                                        marginBottom: "5px",
                                        display: "block",
                                    }}
                                >
                                    {filter.label}
                                </label>
                                {filter.type === "dropdown" ? (


                                    <select
                                        id={`filter-${index}`}
                                        value={filter.value || ""}
                                        onChange={(e) => handledropdown(filter.key, e, "top")}
                                        style={{
                                            width: "100%",
                                            minHeight: "40px",
                                            fontSize: "14px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            padding: "5px",
                                        }}
                                    >
                                        <option value="">Select</option>
                                        {filter.key === "Branch"
                                            ? branchOption.map((item, idx) => (
                                                <option key={idx} value={item.BranchName}>
                                                    {item.BranchName}
                                                </option>
                                            ))
                                            : filter.key === "StockType" && (
                                                <>
                                                    <option value="Labelled">Labelled</option>
                                                    <option value="UnLabelled">UnLabelled</option>
                                                </>
                                            )}
                                    </select>

                                ) : (
                                    <Select
                                        id={`filter-${index}`}
                                        isClearable
                                        value={selectedOption}
                                        options={selectOptions}
                                        onChange={(e) => inputselectchange(filter.key, e, 'top')}
                                        isSearchable={true}
                                        styles={{
                                            container: (base) => ({
                                                ...base,
                                                width: "100%",
                                            }),
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "40px",
                                                fontSize: "14px",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                        }}
                                    />
                                )}
                            </Grid>
                        );
                    })}
            </Grid>
        </div>
    )

}